@if (appState) {
  <app-expandable-section title="{{'Punctuality settings' | translate}}" class="punctuality-config section">
    <div class="form">
      <mat-form-field appearance="fill">
        <mat-label>{{'Early' | translate}} (s)</mat-label>
        <input matInput type="number" [(ngModel)]="punctualityConfig.early" (change)="updatePunctualityConfig()">
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>{{'On time' | translate}} (s)</mat-label>
        <input matInput type="number" [(ngModel)]="punctualityConfig.onTime" (change)="updatePunctualityConfig()">
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>{{'Late' | translate}} (s)</mat-label>
        <input matInput type="number" [(ngModel)]="punctualityConfig.lateLevel1" (change)="updatePunctualityConfig()">
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>{{'More late' | translate}} (s)</mat-label>
        <input matInput type="number" [(ngModel)]="punctualityConfig.lateLevel2" (change)="updatePunctualityConfig()">
      </mat-form-field>
    </div>
    <div class="visual">
      <div class="slots">
        <div class="slot early" [style.background]="COLORS.Red">
          <div class="label">{{punctualityConfig.early}}</div>
          <div class="text">{{'Early' | translate}}</div>
        </div>
        <div class="slot onTime" [style.background]="COLORS.Green">
          <div class="label">{{punctualityConfig.onTime}}</div>
          <div class="text">{{'On time' | translate}}</div>
        </div>
        <div class="slot lateLevel1" [style.background]="COLORS.Yellow">
          <div class="label">{{punctualityConfig.lateLevel1}}</div>
          <div class="text">{{'Late' | translate}}</div>
        </div>
        <div class="slot lateLevel2" [style.background]="COLORS.Orange">
          <div class="label">{{punctualityConfig.lateLevel2}}</div>
          <div class="text">{{'More late' | translate}}</div>
        </div>
        <div class="slot lateLevel3" [style.background]="COLORS.Pink">
          <div class="text">{{'Most late' | translate}}</div>
        </div>
      </div>
    </div>
  </app-expandable-section>

  <app-expandable-section title="{{'Warnings' | translate}}" class="section settings">
    @for (warningType of warnings; track warningType) {
      <div class="setting">
        <h3>{{warningType | formatWarningMessageType:'shortHeader' }}</h3>
        <p>{{warningType | formatWarningMessageType:'description' }}</p>
        <mat-slide-toggle [ngModel]="warningConfig.isVisible(warningType)"
          (change)="updateWarningConfig(warningType)">
          <div class="toggle-item">
            <div class="text-x-small">{{getSwitchText(warningType)}}</div>
          </div>
        </mat-slide-toggle>
      </div>
    }
  </app-expandable-section>

  <app-expandable-section title="{{'Home view' | translate}}" class="section settings">
    @for (widget of homeViewWidgets(); track widget.id) {
      <div class="setting">
        <h3>{{ widget.title | translate }}</h3>
        <p>{{ widget.description | translate }}</p>
        <mat-slide-toggle
          [checked]="widget.visible"
          (change)="updateHomeViewWidgetVisibility(widget.id, $event.checked)">
          <div class="toggle-item">
            <div class="text-x-small">{{ widget.visible ? 'On' : 'Off' }}</div>
          </div>
        </mat-slide-toggle>
      </div>
    }
    <div class="setting">
      <h3>{{'Widget layout' | translate}}</h3>
      <p>{{'Resets the saved size, position, and collapse state of all widgets to their defaults.' | translate}}</p>
      <button mat-stroked-button (click)="resetWidgetSettings()" type="button">
        {{'Reset widget settings' | translate}}
      </button>
    </div>
  </app-expandable-section>

  @if (showDeveloperData) {
    <app-expandable-section initIsOpen="false" title="{{'Developer data' | translate}}" class="section">
      <div class="appState">
        <div class="properties">
          <div class="property">
            <div class="label" translate>Context</div>
            <div class="value">{{appState.selectedContext}}</div>
          </div>
          <div class="property">
            <div class="label" translate>Left panel visible</div>
            <div class="value">{{appState.leftPanelIsVisible}}</div>
          </div>
          <div class="property">
            <div class="label" translate>Left total width</div>
            <div class="value">{{appState.leftTotalWidth}}</div>
          </div>
          <div class="property">
            <div class="label" translate>Lang</div>
            <div class="value">{{lang}}</div>
          </div>
        </div>
      </div>
    </app-expandable-section>
  }

  @if (showDeveloperData) {
    <app-expandable-section initIsOpen="false" title="{{'Traffic Deviations' | translate}}"
      class="section settings">
      <div class="setting">
        <h3 translate>Show Form Values as Json</h3>
        <p translate>This shows the form values at the bottom of the form</p>
        <mat-slide-toggle [(ngModel)]="trafficDeviationsConfig.showFormValuesAsJson"
          (change)="updateTrafficDeviationConfig()">
          <div class="toggle-item">
            <div class="text-x-small">{{trafficDeviationsConfig.showFormValuesAsJson ? 'On' : 'Off'}}</div>
          </div>
        </mat-slide-toggle>
      </div>
      <div class="setting">
        <h3 translate>Show button for printing whats not validated</h3>
        <p translate>This shows a new button next to the publish button</p>
        <mat-slide-toggle [(ngModel)]="trafficDeviationsConfig.showPrintNotValidatedListButton"
          (change)="updateTrafficDeviationConfig()">
          <div class="toggle-item">
            <div class="text-x-small">{{trafficDeviationsConfig.showPrintNotValidatedListButton ? 'On' : 'Off'}}</div>
          </div>
        </mat-slide-toggle>
      </div>
    </app-expandable-section>
  }
}
